import "./Loader.css"
// For boncing loader
const ThreeDotLoaderBlue = () => (
  <div className="flex justify-center items-center space-x-1 ">
    <div className="w-2 h-2 bg-blue-700 rounded-full animate-dot-blink delay-0"></div>
    <div className="w-2 h-2 bg-blue-700 rounded-full animate-dot-blink delay-200"></div>
    <div className="w-2 h-2 bg-blue-700 rounded-full animate-dot-blink delay-400"></div>
  </div>
);

export default ThreeDotLoaderBlue;